/* ==========================================================
   CPB INSERT PIPELINE FOR MINIMALIST DESIGN
   SINGLE-LINE INPUT VERSION
   A   -> A
   AB  -> A|B
   ABC -> A|B|C
   Only runs on selected product URL handles.
   *** Finds the "Initials" field automatically.
   No CPB-generated IDs required.
========================================================== */

(function () {
  'use strict';

  const ALLOWED_PRODUCTS = [
    'black-saffiano-leather-iphone-case-minimalist'
  ];

  /* Get product handle from URL */
  function getCurrentProductHandle() {
    const parts = window.location.pathname
      .split('/')
      .filter(Boolean);

    const index = parts.indexOf('products');

    return index !== -1
      ? (parts[index + 1] || '')
      : '';
  }

  /* Don't run on other products */
  if (!ALLOWED_PRODUCTS.includes(getCurrentProductHandle())) {
    return;
  }

  /* Native setter for <input>, NOT <textarea> */
  const nativeValueSetter =
    Object.getOwnPropertyDescriptor(
      HTMLInputElement.prototype,
      'value'
    ).set;

  let updating = false;

  document.addEventListener('input', function (event) {

    if (updating) {
      return;
    }

    const field = event.target;

    /* Only single-line text inputs */
    if (
      !(field instanceof HTMLInputElement) ||
      field.type !== 'text'
    ) {
      return;
    }

    /* Find CPB category containing this input */
    const category = field.closest('.cpb-category');

    if (!category) {
      return;
    }

    /* Find category title */
    const titleElement = category.querySelector(
      '.cpb-category-title'
    );

    if (!titleElement) {
      return;
    }

    const title = titleElement.textContent
      .trim()
      .toLowerCase();

    /* Only target Initials */
    if (title !== 'initials') {
      return;
    }

    /* Remove existing pipes */
    let clean = field.value.replace(/\|/g, '');

    /*
       Maximum 3 letters:
       ABC -> A|B|C
       Total = 5 characters
    */
    clean = clean.slice(0, 3);

    /* Add pipes */
    const formatted = clean
      .split('')
      .join('|');

    if (field.value === formatted) {
      return;
    }

    updating = true;

    /*
       Use native input setter so CPB/React
       accepts the new value
    */
    nativeValueSetter.call(
      field,
      formatted
    );

    try {
      field.dispatchEvent(
        new InputEvent('input', {
          bubbles: true,
          inputType: 'insertText',
          data: null
        })
      );
    } catch (e) {
      field.dispatchEvent(
        new Event('input', {
          bubbles: true
        })
      );
    }

    /* Cursor back to end */
    try {
      field.setSelectionRange(
        formatted.length,
        formatted.length
      );
    } catch (e) {}

    updating = false;

  });

})();